/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { HistoryAlbumGift } from "./HistoryAlbumGift";
import { HistoryAlbumUserGiftCount } from "./HistoryAlbumUserGiftCount";

export const protobufPackage = "Reality.Reality.Api";

export interface HistoryAlbumReceiveGiftRecord {
  gift: HistoryAlbumGift | undefined;
  totalCount: number;
  topReceiveUserList: HistoryAlbumUserGiftCount[];
}

function createBaseHistoryAlbumReceiveGiftRecord(): HistoryAlbumReceiveGiftRecord {
  return { gift: undefined, totalCount: 0, topReceiveUserList: [] };
}

export const HistoryAlbumReceiveGiftRecord = {
  encode(message: HistoryAlbumReceiveGiftRecord, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.gift !== undefined) {
      HistoryAlbumGift.encode(message.gift, writer.uint32(10).fork()).ldelim();
    }
    if (message.totalCount !== 0) {
      writer.uint32(16).int64(message.totalCount);
    }
    for (const v of message.topReceiveUserList) {
      HistoryAlbumUserGiftCount.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HistoryAlbumReceiveGiftRecord {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryAlbumReceiveGiftRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.gift = HistoryAlbumGift.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.totalCount = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.topReceiveUserList.push(HistoryAlbumUserGiftCount.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryAlbumReceiveGiftRecord {
    return {
      gift: isSet(object.gift) ? HistoryAlbumGift.fromJSON(object.gift) : undefined,
      totalCount: isSet(object.totalCount) ? globalThis.Number(object.totalCount) : 0,
      topReceiveUserList: globalThis.Array.isArray(object?.topReceiveUserList)
        ? object.topReceiveUserList.map((e: any) => HistoryAlbumUserGiftCount.fromJSON(e))
        : [],
    };
  },

  toJSON(message: HistoryAlbumReceiveGiftRecord): unknown {
    const obj: any = {};
    if (message.gift !== undefined) {
      obj.gift = HistoryAlbumGift.toJSON(message.gift);
    }
    if (message.totalCount !== 0) {
      obj.totalCount = Math.round(message.totalCount);
    }
    if (message.topReceiveUserList?.length) {
      obj.topReceiveUserList = message.topReceiveUserList.map((e) => HistoryAlbumUserGiftCount.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HistoryAlbumReceiveGiftRecord>, I>>(base?: I): HistoryAlbumReceiveGiftRecord {
    return HistoryAlbumReceiveGiftRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HistoryAlbumReceiveGiftRecord>, I>>(
    object: I,
  ): HistoryAlbumReceiveGiftRecord {
    const message = createBaseHistoryAlbumReceiveGiftRecord();
    message.gift = (object.gift !== undefined && object.gift !== null)
      ? HistoryAlbumGift.fromPartial(object.gift)
      : undefined;
    message.totalCount = object.totalCount ?? 0;
    message.topReceiveUserList = object.topReceiveUserList?.map((e) => HistoryAlbumUserGiftCount.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
